<template>
	<el-dialog title="查询服务商信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="background-color: rgb(38 38 38 / 70%);"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">

				<div class="grid-height">
                    <div style="display: flex;padding-top: 5px;">
                    <div style="font-size: 12px;color: rgba(86, 86, 86, 0.96); margin-top:3px; display: flex;">
                  <span style="text-align: right;    width: 77px;display: block; margin-bottom: 10px;" class="title3">筛选条件：</span>
                  <el-checkbox-group v-model="checkboxList" @change="selectConditionChange" style="margin-left: 10px;
    margin-bottom: 10px;">
                    <el-checkbox :label="1">服务商区域符合</el-checkbox>
                    <el-checkbox :label="2">服务商技能符合</el-checkbox>
                  </el-checkbox-group>
                </div>

                <div style="margin-left: 100px;font-size: 12px;color: rgba(86, 86, 86, 0.96); margin-top:3px; display: flex;">
                  <span style="text-align: right;    width: 77px;display: block; margin-bottom: 10px;" class="title3">排序条件：</span>
                  <el-radio-group v-model="formData.orderBy"  style="margin-left: 10px;
    margin-bottom: 10px;" @change="selectOrderBy">
                    <el-radio :label="1">等级优先</el-radio>
                    <el-radio :label="2">工单容量优先</el-radio>
                    <el-radio :label="3">距离优先</el-radio>

                  </el-radio-group>
                </div>

            </div>



					<div class="table_main" style="height: 300px!important; display: flex;">
                        <div style="height: 250px;width:30%;background-color: aquamarine;">
<!--                            <el-image-->
<!--      style="width: 100%; height: 250px"-->
<!--      :src="url"-->
<!--   ></el-image>-->
                          <gdMap :siteMsgs="siteMsgs"></gdMap>
                        </div>
                        <div style="width: 70%;">
						<vxe-grid
                        :stripe="true"
              :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
              :row-config="{height: 30,isHover: true,padding: 0,}"
              :row-style="{ fontSize: '12px',  }"
                        ref="table-m1" :radio-config="{ highlight: true }" @cell-click="cellClickEvent"
							@radio-change="radioChangeEvent" show-overflow height="250"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">
              <template #xxxx="{ row }">
                <el-checkbox  :name="row.id" label="isSendSite"  >网点</el-checkbox>
                <el-checkbox  :name="row.id" label="isSendUser"  >客户</el-checkbox>
              </template>
							<template #form style="">
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="searchEvent" @reset="searchEvent">
									<vxe-form-item title="服务商名称:" field="siteName">
										<template v-slot>
											<el-input v-model="formData.siteName" size="small" clearable  />
										</template>
									</vxe-form-item>
								</vxe-form>
								<div class="clearfix screen-btns" style=" border-bottom: none !important;">
									<div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>

							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid></div>
					</div>
				</div>


                <div>
                <div style=" margin-bottom: 10px;margin-left: 6px;"><span class="title3">服务商排班信息</span>  &nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 12px;">用户期待上门时间:
                   <el-date-picker v-model="orderDataParam.wishBookDate" @change="changeTime" value-format="yyyy-MM-dd HH:mm:ss" type="date" style="width: 150px;"  placeholder="选择日期">
                        </el-date-picker>
                 </span></div>
                <vxe-table
          :stripe="true"
              :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
              :row-config="{height: 30,isHover: true,padding: 0,}"
              :row-style="{ fontSize: '12px',  }"
              show-overflow
              height="160" :column-config="{ resizable: true }"
          :data="tableData"
          :radio-config="{highlight: true}"
          @cell-click="cellClickEvent"
        >
          <vxe-column type="radio" width="60">
            <template #header>
              <!-- <vxe-button type="text" @click="clearRadioRowEevnt" :disabled="!selectRow"></vxe-button> -->
            </template>
          </vxe-column>
          <vxe-column field="orderNo" title="服务单号"></vxe-column>
          <vxe-column field="statName" title="状态"></vxe-column>
          <vxe-column field="serviceTypeName" title="服务类型" show-overflow></vxe-column>
          <vxe-column field="userName" title="用户姓名"></vxe-column>
          <vxe-column field="userMobile" title="用户电话"></vxe-column>
          <vxe-column field="areaName" title="地区" show-overflow></vxe-column>
          <vxe-column field="userAddress" title="地址"></vxe-column>
          <vxe-column field="wishBookDate" title="用户期望上门时间" width="150">
            <template #default="{ row }">
              <span v-if="row.wishBookPeriod">
                {{row.wishBookDate}} -{{row.wishBookPeriod}}
              </span>
              <span v-if="!row.wishBookPeriod">
                {{row.wishBookDate}}
              </span>
            </template>
          </vxe-column>
          <vxe-column field="siteName" title="服务商" show-overflow></vxe-column>
          <vxe-column field="engineerName" title="师傅"></vxe-column>


        </vxe-table>
                </div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import gdMap from '@/components/map/gdMap.vue'
import request from "../../../../router/axios";
export default {
	name: 'siteDialog',
	props: ['visiable', 'multi', 'param','orderId','assginType'],
	mixins: [selectDialogMixins],
	components: { pager ,gdMap},

	created() {
    this.formData.orderId = this.orderId?this.orderId:"",
    this.formData.isCountDistance = this.assginType && this.assginType==3 ?1:0
    this.callBackAssignType = this.assginType?this.assginType:0
    this.orderDataParam.wishBookDate = this.param && this.param.wishBookDate ?this.param.wishBookDate:""
    this.formData.wishBookDate = this.param && this.param.wishBookDate ?this.param.wishBookDate:""
    this.formData.isSelectByArea =1
    this.formData.isSelectByItem =0
		this.initSetting();
	},

	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},

	data() {
		return {
            url:"https://assets-v3.changjing.com.cn/resource/images/homeV3/products/pro_detail6.png",
            tableData: [],
            checkboxList:[1],
			total: 0,
			filterText: '',
			data: [],
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			isRouterAlive: true,
			// 查询参数
			formData: {
				size: 0,
				current: 1,
				searchCount: false,
        wishBookDate:this.param?this.param.wishBookDate?this.param.wishBookDate:"":"",
        areaId : this.param?this.param.areaId?this.param.areaId:'':'',
        brandId : this.param?this.param.brandId?this.param.brandId:'':'',
        smallCategoryId : this.param?this.param.smallCategoryId?this.param.smallCategoryId:'':'',
        orderBy:0
			},
      orderDataParam:{
        wishBookDate:""
      },
			showDialog: true,
			falseValue: true,
			selectMulti: true,
			selectedRow: {

			},
			siteMsgs:[],
		};
	},


	methods: {
		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},

		cellClickEvent(e) {

		},

    //筛选条件选择
    selectConditionChange(value){
      let checkedCount = value.length;
      this.formData.isSelectByArea = 0;
      this.formData.isSelectByItem = 0;
      for (let i = 0; i < checkedCount; i++) {
        if (value[i] == 1){
          this.formData.isSelectByArea =1;
        }
        if (value[i] == 2){
          this.formData.isSelectByItem =1;
        }
      }
      //重新获取服务商
      this.initTableList()
    },
    selectOrderBy(){
      //重新获取服务商
      this.initTableList()
    },
		radioChangeEvent({ row }) {
			this.selectedRow = { id: row.id, name: row.userName,callBackAssignType:this.callBackAssignType }
			//获取航班信息tableData
      this.orderDataParam.siteId = row.id
      this.getSiteNeedDealOrder();

		},
    changeTime(){
      this.getSiteNeedDealOrder();
    },
  getSiteNeedDealOrder(){
    this.$http({
      url: api.soOrder.getNeedDealOrderBySiteUrl,
      method: 'post',
      data: this.orderDataParam,
      isLoading: true,
      modalStrictly: true,
    }).then(response => {
      this.tableData = response.data.data
    })
  },

		commitRow() {
          // 点击确定  选择了那些值
      var nameId = this.selectedRow.id;
      if(!nameId){
        this.$mask.close()
        this.$message.error('请先选择需要指派的服务商！')
        return
      }
			var obj = document.getElementsByName(nameId);
			var s = '';
			for (var i = 0; i < obj.length; i++) {
				if (obj[i].checked) s += obj[i].value + ',';
        if (obj[i].checked){
          if(obj[i].value == "isSendSite"){
            this.selectedRow.isSendSite = 1;
          }else if(obj[i].value == "isSendUser"){
            this.selectedRow.isSendUser = 1
          }
        }
			};
			this.$emit('commitSiteRow', this.selectedRow),
				this.dialogClose()
		},


		// 分页功能
		changeTablePage(page, flag) {
			this.initTableList();
		},


		// 搜索
		searchEvent() {
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},




		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.soOrder.getassignSiteByMapUrl,
				param: this.formData,
				method: 'post',
        isPage:1,
				columns: [
					{ type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
					// { type: "seq", width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '服务商名称',
						field: 'userName',
						// width: 110,
						// fixed: 'left'
					},
					{
						title: '性质',
						field: 'siteTypeName',
					},
					{
						title: '地区',
						field: 'userAddress',
						// width: 100,
					},
					{
						field: 'distance',
						title: '距离',
						// width: 160,
					},
					{
						title: '未完工量',
						field: 'unFinishOrders',
						// width: 80,
					},
					{
						title: '预约日工单量',
						field: 'needFinishOrders',
						// width: 80,

					},
					{
						field: '',
						title: '短信',
						width: 160,
						slots: {
              default : "xxxx"
						}
					},


				]
			};
			this.vxeOption = this.doinitVxeTable(tableOption);
			console.log("vxeOption=====",this.vxeOption)
			this.flushed()
		},

    doinitVxeTable(tableOption) {
      const option = {
        resizable: true,
        showOverflow: true,
        border: 'inner',
        height: document.documentElement.clientHeight-77,
        rowId: 'id',
        printConfig: {
        },
        sortConfig: {
          trigger: 'cell',
          remote: true,
          defaultSort: {
          }
        },
        filterConfig: {
          remote: true
        },
        pagerConfig: {
          pageSize: 100,
          pageSizes: [ 100, 200, 500, 1000]
        },
        exportConfig: {
          // 默认选中类型
          type: 'xlsx',
          // 局部自定义类型
          types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
          // 自定义数据量列表
          modes: ['current', 'all']
        },
        radioConfig: {
          labelField: 'id',
          reserve: true,
          highlight: true
        },
        checkboxConfig:{
          checkStrictly: true,
          showHeader: true,
          trigger: 'row',
          // labelField: 'id',
          reserve: true
        },
        rowConfig: {
          keyField: 'id'
        },
        proxyConfig: {
          seq: true, // 启用动态序号代理
          sort: true, // 启用排序代理
          filter: true, // 启用筛选代理
          props: {
            result: 'result', // 配置响应结果列表字段
            total: 'page.total' // 配置响应结果总页数字段
          },
          ajax: {
            // 接收 Promise 对象
            query: ({page, sorts, filters}) => {
              const queryParams = Object.assign({}, tableOption.param)
              // 处理排序条件
              if(sorts!=null){
                const firstSort = sorts[0]
                if (firstSort) {
                  queryParams.sort = firstSort.property
                  queryParams.order = firstSort.order
                }
              }

              // 处理筛选条件
              filters.forEach(({property, values}) => {
                queryParams[property] = values.join(',')
              })
              return new Promise(resolve => {
                  request({
                    url: tableOption.path,
                    method: tableOption.method,
                    data: queryParams,
                    modalStrictly: true,
                  }).then(response => {
                    if (tableOption.isPage ==1){
                      tableOption.vue.total = response.data.data.length;
                      this.siteMsgs = response.data.data;
                      resolve({
                        result: response.data.data,
                        page: {
                          total: response.data.data.length
                        }
                      })
                    }else {
                      // context.$store.commit("CHANGE_TABLE_DATA_TOTAL", response.data.data.total)
                      tableOption.vue.total = response.data.data.total
                      resolve({
                        result: response.data.data.records,
                        page: {
                          total: response.data.data.total
                        }
                      })
                    }
                  }).catch(() => {
                    // this.tableLoading = false
                  })

              })

            },


          }

        },
        toolbarConfig: {
          // export: true,
          // print: true,
          className :'toolSet',
          custom: {
            icon: 'el-icon-s-tools'
          },
          export: tableOption.export || false,
          // slots: {
          //   buttons: 'toolbar_buttons'
          // }
        },
        columns: tableOption.columns
      }
      return option;
    },



	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 300px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	// width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
	font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 36px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
    display: none;
}
::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title {
    width: 7vw !important;
}
.title3{
    color: black;
    font-weight: 500;
}
::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
    display: inline-block;
    width: 30%!important;
}
// 改变位置
::v-deep .el-dialog {
    top: 50px!important;
}
::v-deep vxe-grid .screen-btns {
    border-bottom: none !important;
}
</style>
